import React from 'react'

/** Simple SVG avatar for testimonial cards (no external placeholder asset). */
function TestimonialAvatar({ hue = 210, label = '' }) {
	const fill = `hsl(${hue}, 35%, 78%)`
	const skin = `hsl(${hue}, 20%, 88%)`
	return (
		<span className="tsr-testimonial-avatar" role="img" aria-label={label || 'Customer photo'}>
			<svg viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
				<circle cx="36" cy="36" r="36" fill={fill} />
				<circle cx="36" cy="28" r="14" fill={skin} />
				<ellipse cx="36" cy="58" rx="22" ry="16" fill={skin} />
			</svg>
		</span>
	)
}

export default TestimonialAvatar
